import { Stack, useTheme } from "@mui/material";
import { mdHeight, SubNavAppBar, xsHeight } from "components/AppBar";
import { tabsOffset } from "components/TabLinks";
import { WasteDateRangePicker } from "components/WasteDateRangePicker";
import { FeatureFlagKey } from "encamp-shared/src/featureFlags";
import { useFeatureFlags } from "hooks/useFeatureFlags";

type Props = {
  shipDateStart?: string;
  shipDateEnd?: string;
  onChange: (next: { shipDateStart?: string; shipDateEnd?: string }) => void;
};

export function TenantWasteStreamsDateFilter({ shipDateStart, shipDateEnd, onChange }: Props) {
  const theme = useTheme();
  const { featureFlags } = useFeatureFlags();
  const isLeftNavV2 = featureFlags[FeatureFlagKey.LeftNavV2];

  return (
    <SubNavAppBar
      sx={{
        py: 2,
        px: 3,
        borderBottom: "1px solid",
        borderColor: theme.palette.divider,
        ...(!isLeftNavV2 && {
          top: {
            xs: theme.spacing(xsHeight + tabsOffset),
            md: theme.spacing(mdHeight + tabsOffset),
          },
        }),
      }}
    >
      <Stack direction={{ xs: "column", md: "row" }} alignItems="start" spacing={2}>
        <WasteDateRangePicker
          startDate={shipDateStart}
          endDate={shipDateEnd}
          onAccept={(next) =>
            onChange({ shipDateStart: next.startDate, shipDateEnd: next.endDate })
          }
        />
      </Stack>
    </SubNavAppBar>
  );
}
